(function() {
    'use strict';

    angular
        .module('returnLetterApp')
        .controller('ReturnLetterProcessDialogController', ReturnLetterProcessDialogController);

    ReturnLetterProcessDialogController.$inject = ['$scope', '$uibModalInstance', 'returnLetter', 'ReturnLetterService', '$location', 'RETURN_LETTER','CommonService','$window','Upload','authExpiredInterceptor','$log'];

    function ReturnLetterProcessDialogController ($scope, $uibModalInstance, returnLetter, ReturnLetterService, $location, RETURN_LETTER, CommonService, $window, Upload,authExpiredInterceptor,$log) {
    	var processLetterDlgCtr = this;
    	processLetterDlgCtr.cancel= cancel;
    	processLetterDlgCtr.doProcessLetter = doProcessLetter;
    	processLetterDlgCtr.errorMessage = null;
    	processLetterDlgCtr.returnLetter = returnLetter;
    	processLetterDlgCtr.loadProcessLetterByPolicyNum = loadProcessLetterByPolicyNum;
    	processLetterDlgCtr.processResults = RETURN_LETTER.PROCESS_RESULTS;
    	processLetterDlgCtr.returnLetter.processResultCode = "";
    	processLetterDlgCtr.returnLetter.mobileCode = "84";
    	processLetterDlgCtr.returnLetter.homeCode = "84";
    	processLetterDlgCtr.returnLetter.compCode = "84";
    	processLetterDlgCtr.lstNationality = CommonService.query({masterurl:'nationality'});
    	processLetterDlgCtr.lstProvince = CommonService.query({masterurl:'province'});
    	function loadProcessLetterByPolicyNum() {
    		processLetterDlgCtr.policyNum = returnLetter.policyNum;
    		processLetterDlgCtr.reasonDes = returnLetter.reasonDes;
    	}
		  function doProcessLetter() {
			var data = [];
			$scope.loading=true;
			if (processLetterDlgCtr.returnLetter.policyNum !== null) {
				if (processLetterDlgCtr.attachment !== null && processLetterDlgCtr.attachment != undefined) {
					data['file'] = processLetterDlgCtr.attachment;
					data['returnLetterDTO'] = new Blob([ JSON
							.stringify(processLetterDlgCtr.returnLetter) ], {
						type : "application/json"
					});
				
				Upload.upload(
						{
							url : GLOBAL_URL
									+ 'api/ga/return-letter/do-process-letter?_csrf='
									+ authExpiredInterceptor.getCSRF(),
							data : data
						}).then(
						function(resp) {
							 $scope.loading=false;
							 if(resp.data.flagError==0){
								processLetterDlgCtr.checkCreate = true;
								processLetterDlgCtr.formProcessLetter.$setPristine();
								processLetterDlgCtr.formProcessLetter.$setUntouched();
							 }else{
								processLetterDlgCtr.checkCreate = false;
							 }
							$log.debug('Success ' + resp.config.data.file.name
									+ 'uploaded. Response: ' + resp.data);
							$uibModalInstance.close(resp);
						},
						function(resp) {
							
						},
						function(evt) {
							var progressPercentage = parseInt(100.0
									* evt.loaded / evt.total);
							$log.debug('progress: ' + progressPercentage + '% '
										+ evt.config.data.file.name);
							});
				}else{
					ReturnLetterService.post({uri:'do-process-letter-not-file'},processLetterDlgCtr.returnLetter, function(result) {
						if (result) {
							$scope.loading = false;
							processLetterDlgCtr.returnLetter = result;
							$uibModalInstance.close(result);
						} else {
							$scope.loading = false;
						}
					}, function(error){
						$scope.loading = false;
				});
				}
			} 
		  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    	  processLetterDlgCtr.getAllDistrictByProvince = function(cityCode,cityDesc){
    		  processLetterDlgCtr.returnLetter.cityCodeUpdate = cityCode;
    		  processLetterDlgCtr.returnLetter.cityDescUpdate = cityDesc;
    			if (cityCode != null || cityCode != undefined && (num != null || num != undefined)){
    				processLetterDlgCtr.lstDistrict = CommonService.query({masterurl:'district',provinceCode:cityCode});
    			}else{
    				processLetterDlgCtr.lstDistrict = null;
    			}
    		};
    		processLetterDlgCtr.getAllWardByDistrict = function(districtCode,districtDesc){
    			processLetterDlgCtr.returnLetter.districtCodeUpdate = districtCode
    			processLetterDlgCtr.returnLetter.districtDescUpdate = districtDesc;
    			if (districtCode != null || districtCode != undefined && (districtCode != null || districtCode != undefined)){
    				processLetterDlgCtr.lstWard = CommonService.query({masterurl:'ward',districtCode:districtCode});
    			}else{
    				processLetterDlgCtr.lstWard = null;
    			}
    		};
    		processLetterDlgCtr.getWardDesc = function(wardCode,wardDesc){
    			processLetterDlgCtr.returnLetter.wardCodeUpdate = wardCode
    			processLetterDlgCtr.returnLetter.wardDescUpdate = wardDesc;
    		};
    		processLetterDlgCtr.download=function() {
    			//danh cho ie
    			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
    				if(processLetterDlgCtr.attachment.content!=undefined){
    					var byteCharacters = atob(processLetterDlgCtr.attachment.content);
    					var byteNumbers = new Array(byteCharacters.length);
    					for (var i = 0; i < byteCharacters.length; i++) {
    						byteNumbers[i] = byteCharacters.charCodeAt(i);
    					}
    					var byteArray = new Uint8Array(byteNumbers);
    					var blob=new Blob([byteArray], { type: processLetterDlgCtr.attachment.type+';charset=utf-8' });
    					window.navigator.msSaveBlob(blob, processLetterDlgCtr.attachment.name);
    				}else{
    					 var blob=new Blob([processLetterDlgCtr.attachment], { type: processLetterDlgCtr.attachment.type+';charset=utf-8' });
    					 window.navigator.msSaveBlob(blob, processLetterDlgCtr.attachment.name);
    				 }
    			}else{
    				//truong hop file da luu duoi database
    				if(processLetterDlgCtr.attachment.content!=undefined){
    					var byteCharacters = atob(processLetterDlgCtr.attachment.content);
    					var byteNumbers = new Array(byteCharacters.length);
    					for (var i = 0; i < byteCharacters.length; i++) {
    						byteNumbers[i] = byteCharacters.charCodeAt(i);
    					}
    					var byteArray = new Uint8Array(byteNumbers);
    					var blob=new Blob([byteArray], { type: processLetterDlgCtr.attachment.type+';charset=utf-8' });
    					var url = $window.URL || $window.webkitURL;
    					var aTag = document.createElement("a");
    					aTag.style = "display: none";
    					aTag.href = url.createObjectURL(blob);
    					aTag.download = processLetterDlgCtr.attachment.name;
    					aTag.click();
    				}else{
    					//truong hop file luu tam tren man hinh
    					var blob=new Blob([processLetterDlgCtr.attachment], { type: processLetterDlgCtr.attachment.type+';charset=utf-8' });
    					var url = $window.URL || $window.webkitURL;
    					var aTag = document.createElement("a");
    					aTag.style = "display: none";
    					aTag.href = url.createObjectURL(blob);
    					aTag.download = processLetterDlgCtr.attachment.name;
    					aTag.click();
    				}
    			}
    		};
    		processLetterDlgCtr.sendToLas = function() {
    			var data = [];
    			$scope.loading=true;
    			if (processLetterDlgCtr.returnLetter.policyNum !== null) {
    				if (processLetterDlgCtr.attachment) {
    					data['file'] = processLetterDlgCtr.attachment;
    					data['returnLetterDTO'] = new Blob([ JSON
    							.stringify(processLetterDlgCtr.returnLetter) ], {
    						type : "application/json"
    					});
    				}
    				Upload.upload(
    						{
    							url : GLOBAL_URL
    									+ 'api/ga/return-letter/do-send-to-las?_csrf='
    									+ authExpiredInterceptor.getCSRF(),
    							data : data
    						}).then(
    						function(resp) {
    							 $scope.loading=false;
    							 if(resp.data.flagError==0){
    								processLetterDlgCtr.checkCreate = true;
    								processLetterDlgCtr.formProcessLetter.$setPristine();
    								processLetterDlgCtr.formProcessLetter.$setUntouched();
    							 }else{
    								processLetterDlgCtr.checkCreate = false;
    							 }
    							$log.debug('Success ' + resp.config.data.file.name
    									+ 'uploaded. Response: ' + resp.data);
    						},
    						function(resp) {
    							
    						},
    						function(evt) {
    							var progressPercentage = parseInt(100.0
    									* evt.loaded / evt.total);
    							$log.debug('progress: ' + progressPercentage + '% '
    									+ evt.config.data.file.name);
    						});
    			}
    		} 
    }
})();
